import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const intentApi = {
  putSetFavoriteIntent: (request) => {
    const { data } = request
    return instance().put(`/intents/favorite-intent`, data)
  }
}

export default intentApi



// WEBPACK FOOTER //
// ./src/api/intent.js